module.exports = ".button-wrapper {\n    text-align: right;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/credit/credit-error/credit-error.component.css
// module id = ./src/app/organization/components/credit/credit-error/credit-error.component.css
// module chunks = main